(function() {
    'use strict';

a3_cabin_reports.controller('MedicalIncidentCtrl', MedicalIncidentCtrl);

    /**
    * @memberof CabinReports
    * @ngdoc controller
    * @name MedicalIncidentCtrl
    * @description 
    *  Manages the Medical Incident Modal View
    * @ngInject
    */
function MedicalIncidentCtrl($scope, $timeout, $uibModalInstance, ModalDialogResultFactory, MedicalIncidentFactory, med) {

		$scope.clearField = clearField;
        $scope.clearMedicalRemarks = clearMedicalRemarks;
        $scope.clearMedicalSignature = clearMedicalSignature
         
		$scope.ok = ok; 
        $scope.cancel = cancel;    
    
        var result = ModalDialogResultFactory.createNew();

		if (med == null) {
			result.Object = MedicalIncidentFactory.createNew();
			result.isInsertMode = true;
		} else {
			result.Object = MedicalIncidentFactory.fromObject(med);
			result.isInsertMode = false;
		}

		$scope.med = result.Object;
    
        $timeout(function() {
			$('.modal-medical').find('textarea').each(function(index, item) {
				if (item.value != '')
					autoAdjustTextarea(item);
			});
		}, 500);
    
        /**
         * Clear Field
         * @memberof MedicalIncidentCtrl
         */
        function clearField(target, fieldName) {
			if (target[fieldName] == null || target[fieldName] == '') return false;
			bootbox.dialog({
				message: "Please confirm that you wish to clear this field",
				title: "<strong>Attention<strong>",
				buttons: {
					cancel: {
						label: "Cancel",
						className: "btn-default",
						callback: function() {}
					},
					ok: {
						label: "Ok",
						className: "btn-warning",
						callback: function() {
							target[fieldName] = null;
							$scope.$apply();
							return true;
						}
					}
				}
			});
		}

        /**
         * Clear  medical remarks
         * @memberof MedicalIncidentCtrl
         */
		function clearMedicalRemarks(med) {
			$scope.clearField(med, "Symptoms");
		}

        /**
         * Clear medical signature function
         * @memberof MedicalIncidentCtrl
         */
		function clearMedicalSignature(med) {
			$scope.clearField(med, "Signature");
			//med.Signature = null;
		}

        /**
         * Close modal after u check Name
         * @memberof MedicalIncidentCtrl
         */
        function ok() {
			if ((result.Object.Name == null) || (result.Object.Name == ''))
				result.Object.Name = '-';
			$uibModalInstance.close(result);
		}
 
        /**
         * Close modal
         * @memberof MedicalIncidentCtrl
         */
        function cancel() {
			$uibModalInstance.close(null);
		}



	}

})();